// extracted by mini-css-extract-plugin
export var btn = "main-module--btn--814dc";
export var title = "main-module--title--f569e";